var map = {
	"./creditDebit.png": "pSbC",
	"./dashStat.png": "iGSX",
	"./invoice.png": "KRGj",
	"./manage.png": "FOL7",
	"./newReg.png": "yEZL",
	"./serviceProvider.png": "CDF6",
	"./simplified.png": "MyXd",
	"./sme.png": "F6D/",
	"./solCert.png": "2zyj",
	"./solReg.png": "nKzC",
	"./standard.png": "ibD4",
	"./taxReturn.png": "40sy",
	"./viewInvoices.png": "/a3y"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "IrsO";